module.exports = require("base64-js");